import {pluralize} from "@pg-mono/string-utils";

import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {OfferType} from "../../../offer/types/OfferType";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {IChosenStats} from "../BoosterDetail";
import {IPropertyDetailBoosterStats} from "../BoosterDetail.test";
import {ILocalStorageStats} from "../hooks/use_random_booster_content";

const garageTextPluralize = pluralize(["garaż", "garaże", "garaży"]);
const lastTextPluralize = pluralize(["ostatni", "ostatnie", "ostatnich"]);
const leftTextPluralize = pluralize(["został", "zostały", "zostało"]);

export const getBoosterText = (
    boosterStats: {stats: IChosenStats; tempBoosterContent: ILocalStorageStats},
    offer: IOfferDetail | IPropertyDetailOffer,
    property?: IPropertyDetailBoosterStats
) => {
    const isFlatProperty = property?.offer.type === OfferType.FLAT;
    const isFlatOffer = offer?.type === OfferType.FLAT;

    if (boosterStats.tempBoosterContent.group === "building_param") {
        // Case with building parameter
        const spanText = boosterStats.stats.left
            ? getLastOfferInfoText(isFlatOffer || isFlatProperty ? OfferType.FLAT : OfferType.HOUSE, boosterStats?.stats.left)
            : "";

        //area text
        const areaOfferText = `W tej inwestycji został${!isFlatOffer ? ` ${spanText}` : `o ${spanText}`} o metrażu ${boosterStats?.stats.type}.`;
        const areaPropertyText = `To ${spanText} ${!isFlatProperty ? `o powierzchni ${boosterStats?.stats.type} na tym osiedlu` : `w tej inwestycji z takim metrażem`}.`;

        //rooms text
        const roomsOfferText = `W tej inwestycji został${!isFlatOffer ? ` ${spanText}` : `o ${spanText}`} ${boosterStats?.stats.type}.`;
        const roomsPropertyText = `To ${spanText} ${boosterStats?.stats.type} w tej inwestycji.`;

        //garage text
        const garageOfferText = boosterStats.stats.left
            ? `W tej inwestycji ${leftTextPluralize(boosterStats.stats.left)} ${lastTextPluralize(boosterStats.stats.left)} ${boosterStats.stats.left} ${garageTextPluralize(boosterStats.stats.left)}.`
            : "";
        const garagePropertyText = `To ${spanText} ${!isFlatProperty ? `z garażem na tym osiedlu` : `z garażem w tej inwestycji`}.`;

        //floor text
        const floorOfferText = `W tej inwestycji został${!isFlatOffer ? ` ${spanText}` : `o ${spanText}`} ${boosterStats?.stats.type}.`;
        const floorPropertyText = `To ${spanText} ${boosterStats?.stats.type} tej inwestycji.`;

        //additional area text
        const additionalAreaOfferText = `W tej inwestycji został${!isFlatOffer ? ` ${spanText} z tarasem` : `o ${spanText} z balkonem`}.`;
        const additionalAreaPropertyText = `To ${spanText} ${!isFlatProperty ? `z tarasem na tym osiedlu` : `z balkonem w tej inwestycji`}.`;

        //exposure text
        const exposurePropertyText = `To ${spanText} z oknami ${boosterStats?.stats.type && boosterStats.stats.type} w tej inwestycji.`;

        let generatedText: string;
        switch (boosterStats.tempBoosterContent.content) {
            case "area":
                generatedText = `Złap okazję! ${property ? areaPropertyText : areaOfferText}`;
                break;
            case "garage":
                generatedText = `Złap okazję! ${property ? garagePropertyText : garageOfferText}`;
                break;
            case "rooms":
                generatedText = `Złap okazję! ${property ? roomsPropertyText : roomsOfferText}`;
                break;
            case "floor":
                generatedText = `Złap okazję! ${property ? floorPropertyText : floorOfferText}`;
                break;
            case "balcony":
                generatedText = `Złap okazję! ${property ? additionalAreaPropertyText : additionalAreaOfferText}`;
                break;
            case "terrace":
                generatedText = `Złap okazję! ${property ? additionalAreaPropertyText : additionalAreaOfferText}`;
                break;
            default:
                //exposure type
                generatedText = `Złap okazję! ${exposurePropertyText}`;
        }
        return {generatedText, spanText};
    }
};

export const getLastOfferInfoText = (offer: OfferType, leftProperties: number): string => {
    return leftProperties === 1
        ? offer === OfferType.HOUSE
            ? "ostatni dom"
            : "ostatnie mieszkanie"
        : offer === OfferType.HOUSE && leftProperties === 2
          ? "jeden z ostatnich domów"
          : "jedno z ostatnich mieszkań";
};
import {pluralize} from "@pg-mono/string-utils";

import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {OfferType} from "../../../offer/types/OfferType";
import {IPropertyDetailOffer} from "../../../property/types/IPropertyDetailOffer";
import {IChosenStats} from "../BoosterDetail";
import {IPropertyDetailBoosterStats} from "../BoosterDetail.test";
import {ILocalStorageStats} from "../hooks/use_random_booster_content";

const garageTextPluralize = pluralize(["garaż", "garaże", "garaży"]);
const lastTextPluralize = pluralize(["ostatni", "ostatnie", "ostatnich"]);
const leftTextPluralize = pluralize(["został", "zostały", "zostało"]);

export const getBoosterText = (
    boosterStats: {stats: IChosenStats; tempBoosterContent: ILocalStorageStats},
    offer: IOfferDetail | IPropertyDetailOffer,
    property?: IPropertyDetailBoosterStats
) => {
    const isFlatProperty = property?.offer.type === OfferType.FLAT;
    const isFlatOffer = offer?.type === OfferType.FLAT;

    if (boosterStats.tempBoosterContent.group === "building_param") {
        // Case with building parameter
        const spanText = boosterStats.stats.left
            ? getLastOfferInfoText(isFlatOffer || isFlatProperty ? OfferType.FLAT : OfferType.HOUSE, boosterStats?.stats.left)
            : "";

        //area text
        const areaOfferText = `W tej inwestycji został${!isFlatOffer ? ` ${spanText}` : `o ${spanText}`} o metrażu ${boosterStats?.stats.type}.`;
        const areaPropertyText = `To ${spanText} ${!isFlatProperty ? `o powierzchni ${boosterStats?.stats.type} na tym osiedlu` : `w tej inwestycji z takim metrażem`}.`;

        //rooms text
        const roomsOfferText = `W tej inwestycji został${!isFlatOffer ? ` ${spanText}` : `o ${spanText}`} ${boosterStats?.stats.type}.`;
        const roomsPropertyText = `To ${spanText} ${boosterStats?.stats.type} w tej inwestycji.`;

        //garage text
        const garageOfferText = boosterStats.stats.left
            ? `W tej inwestycji ${leftTextPluralize(boosterStats.stats.left)} ${lastTextPluralize(boosterStats.stats.left)} ${boosterStats.stats.left} ${garageTextPluralize(boosterStats.stats.left)}.`
            : "";
        const garagePropertyText = `To ${spanText} ${!isFlatProperty ? `z garażem na tym osiedlu` : `z garażem w tej inwestycji`}.`;

        //floor text
        const floorOfferText = `W tej inwestycji został${!isFlatOffer ? ` ${spanText}` : `o ${spanText}`} ${boosterStats?.stats.type}.`;
        const floorPropertyText = `To ${spanText} ${boosterStats?.stats.type} tej inwestycji.`;

        //additional area text
        const additionalAreaOfferText = `W tej inwestycji został${!isFlatOffer ? ` ${spanText} z tarasem` : `o ${spanText} z balkonem`}.`;
        const additionalAreaPropertyText = `To ${spanText} ${!isFlatProperty ? `z tarasem na tym osiedlu` : `z balkonem w tej inwestycji`}.`;

        //exposure text
        const exposurePropertyText = `To ${spanText} z oknami ${boosterStats?.stats.type && boosterStats.stats.type} w tej inwestycji.`;

        let generatedText: string;
        switch (boosterStats.tempBoosterContent.content) {
            case "area":
                generatedText = `Złap okazję! ${property ? areaPropertyText : areaOfferText}`;
                break;
            case "garage":
                generatedText = `Złap okazję! ${property ? garagePropertyText : garageOfferText}`;
                break;
            case "rooms":
                generatedText = `Złap okazję! ${property ? roomsPropertyText : roomsOfferText}`;
                break;
            case "floor":
                generatedText = `Złap okazję! ${property ? floorPropertyText : floorOfferText}`;
                break;
            case "balcony":
                generatedText = `Złap okazję! ${property ? additionalAreaPropertyText : additionalAreaOfferText}`;
                break;
            case "terrace":
                generatedText = `Złap okazję! ${property ? additionalAreaPropertyText : additionalAreaOfferText}`;
                break;
            default:
                //exposure type
                generatedText = `Złap okazję! ${exposurePropertyText}`;
        }
        return {generatedText, spanText};
    }
};

export const getLastOfferInfoText = (offer: OfferType, leftProperties: number): string => {
    return leftProperties === 1
        ? offer === OfferType.HOUSE
            ? "ostatni dom"
            : "ostatnie mieszkanie"
        : offer === OfferType.HOUSE && leftProperties === 2
          ? "jeden z ostatnich domów"
          : "jedno z ostatnich mieszkań";
};
